import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
// import { routerReducer, routerMiddleware } from 'react -router-redux';
import { connectRouter, routerMiddleware } from 'connected-react-router'

// import * as dataEntry from '../_dataEntry/dataEntry.duck';
import * as portfolioEntry from '../portfolioEntryWizard/portfolioEntry.duck';
import * as userManager from '../home/home.duck';
import * as stripePayments from '../payments/stripe/stripe.duck';
import * as shoppingCart from '../shoppingCart/shoppingCart.duck';
import * as account from '../account/account.duck';
import * as portfolio from '../portfolio/portfolio.duck';
import * as admin from '../admin/admin.duck';

import * as confirmBox from '../components/confirmBox/confirmBox.duck';

export const ducks = {
  // dataEntry,
  portfolioEntry,
  userManager,
  stripePayments,
  shoppingCart,
  confirmBox,
  account,
  portfolio,
  admin
};

function configureStore(history, initialState) {

  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  const reducers = {};

  for (var duck in ducks) {
    reducers[duck] = ducks[duck].default;
  }

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history)
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js